export default __webpack_public_path__ + "static/bioage-se-93bf10febd4cf6e54578f55b9cf51ea4.png";